var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ql-container ql-snow",staticStyle:{"border":"0px"}},[_c('div',{staticClass:"ql-editor",staticStyle:{"padding-left":"8px","padding-right":"8px"},domProps:{"innerHTML":_vm._s(_vm.randerContent)}})])}
var staticRenderFns = []

export { render, staticRenderFns }